import { createContext } from "react";

export const initialState = {
    responseStatus: null, // null | covered | no_coverage | arriving
    selectedAddress: "",
    selectedCodeTopClient: null,
    isLoading: false,
    listOfOffers: [],
    notifyModalOpen: false, // nuovo flag per la modale "Avvisami"
    language: "it", // lingua di default
    focusAddressInput: false // nuovo flag per il focus sull'input
  };


export const GlobalContext = createContext({
  store: initialState,
  updateStore: () => {},
});
